import { TimeRangeKey } from '../types'

export const formatTime = (value: string): string => {
  const date = new Date(value)
  return date.toLocaleTimeString('en-IN', {
    hour: '2-digit',
    minute: '2-digit',
    hour12: true,
    timeZone: 'Asia/Kolkata'
  })
}

export const getDateFormatter = (timeRange: TimeRangeKey) => {
  const isLongTerm = ['1Y', '5Y', 'MAX'].includes(timeRange)
  return (value: string) => {
    const date = new Date(value)
    return date.toLocaleDateString("en-IN", {
      year: isLongTerm ? "numeric" : undefined,
      month: "short",
      day: isLongTerm ? undefined : "numeric"
    })
  }
}